import { URL_PAGE_REGEXP } from "../constants"
import type { MenuGroup, MenuItem } from "../types"

export const isMenuItemActive = (menuItem: MenuItem): boolean =>
  menuItem.path.match(URL_PAGE_REGEXP)?.[0] === (window.location.pathname.match(URL_PAGE_REGEXP)?.[0] || "")

export const isMenuGroupActive = (group: MenuGroup): boolean => group.children.some(isMenuItemActive)
